var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubventions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0927 8.66984C9.39513 8.71596 8.70327 8.82575 8.02573 8.99783C7.39193 8.24005 6.59237 7.63807 5.68882 7.23837C5.62795 7.21358 5.5628 7.20104 5.49708 7.20146C5.43136 7.20187 5.36636 7.21524 5.30582 7.24079C5.24527 7.26634 5.19036 7.30358 5.14422 7.35037C5.09808 7.39716 5.06163 7.45258 5.03694 7.51347C5.01271 7.57245 5.00015 7.63557 4.99994 7.69932V10.5886C4.08818 11.2014 3.34093 12.0287 2.82385 12.9979H1.49992C1.36757 12.998 1.24064 13.0505 1.14694 13.1439C1.05324 13.2374 1.0004 13.3641 1 13.4964V16.4954C1.00008 16.6279 1.05278 16.755 1.14651 16.8487C1.24025 16.9424 1.36736 16.9951 1.49992 16.9952H2.82385C3.18809 18.3963 4.06347 19.6106 5.27788 20.3992L4.51623 22.2418C4.39801 22.5558 4.40934 22.904 4.54774 23.2097C4.68614 23.5154 4.94029 23.7537 5.25433 23.8722C5.29563 23.8877 5.33767 23.901 5.38031 23.9123C5.73211 24.0369 6.11757 24.0271 6.46259 23.8848C6.80762 23.7425 7.08785 23.4777 7.24941 23.1414L7.91444 21.5308C9.99296 22.0851 12.1857 22.0427 14.2412 21.4085L14.9573 23.141C15.1189 23.4783 15.3998 23.7438 15.7457 23.8861C16.0917 24.0285 16.4781 24.0377 16.8304 23.912C17.1551 23.8269 17.4328 23.6164 17.6023 23.3268C17.7718 23.0372 17.8194 22.6921 17.7345 22.3674C17.7236 22.3247 17.7102 22.2826 17.6944 22.2414L16.8304 20.1491C17.6423 19.6441 18.3187 18.9485 18.8007 18.1229C19.2827 17.2972 19.5558 16.3663 19.5963 15.4112C19.5834 14.2306 19.1742 13.0885 18.4344 12.1683",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6001 16.0842C21.2001 16.0842 22 15.2846 22 14.0848",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24927 12.4967C7.3156 12.4967 7.37922 12.523 7.42612 12.5699C7.47303 12.6168 7.49938 12.6804 7.49938 12.7467",
    stroke: "#162056",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99976 12.7467C6.99976 12.6804 7.02611 12.6168 7.07301 12.5699C7.11992 12.523 7.18353 12.4967 7.24987 12.4967",
    stroke: "#162056",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24987 12.9961C7.21702 12.9961 7.1845 12.9897 7.15415 12.9771C7.12381 12.9645 7.09624 12.9461 7.07301 12.9229C7.04979 12.8997 7.03136 12.8721 7.01879 12.8418C7.00623 12.8114 6.99976 12.7789 6.99976 12.7461",
    stroke: "#162056",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49938 12.7461C7.49938 12.7789 7.49291 12.8114 7.48034 12.8418C7.46777 12.8721 7.44935 12.8997 7.42612 12.9229C7.4029 12.9461 7.37533 12.9645 7.34498 12.9771C7.31464 12.9897 7.28211 12.9961 7.24927 12.9961",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3598 11.1199C16.268 11.2155 16.142 11.2707 16.0095 11.2736C15.877 11.2764 15.7487 11.2265 15.6529 11.1349L15.6379 11.1199L10.8868 6.16343C10.4377 5.71471 10.1413 5.13612 10.0394 4.50961C9.93758 3.8831 10.0355 3.24043 10.3193 2.67264V2.67264C10.5335 2.24382 10.8467 1.87207 11.2329 1.58804C11.6192 1.30401 12.0674 1.11584 12.5407 1.03905C13.014 0.962266 13.4988 0.999056 13.955 1.14639C14.4113 1.29373 14.826 1.54739 15.1649 1.88645L16 2.72124L16.835 1.88645C17.1741 1.54796 17.5888 1.29481 18.045 1.14782C18.5011 1.00083 18.9856 0.964212 19.4586 1.04097C19.9317 1.11773 20.3797 1.30567 20.7659 1.58934C21.1521 1.87301 21.4654 2.24429 21.6801 2.67264V2.67264C21.964 3.24041 22.062 3.8831 21.9603 4.50967C21.8586 5.13624 21.5622 5.71492 21.1132 6.16374L16.3598 11.1199Z",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubventions);
export default __webpack_public_path__ + "static/media/subventions.12eaa5799f88321fd3f5a488666b795b.svg";
export { ForwardRef as ReactComponent };